export type CreateDeploymentRequestComponentNameRequest = {
  dipByRgn: string;
  cpntId: string;
  forceStgDplyFlg: boolean;
};
